export default class LocationsList extends HTMLElement {
  constructor() {
    super();
    this.locations = [];
    this.blockedLocations = [
      "greensboro",
      "huntsville",
      "westminster",
      "fort worth",
      "winnipeg",
      "spanish fort",
      "minneapolis",
      "atlanta",
      "dallas",
      "charlotte",
      "indianapolis",
    ];
  }

  connectedCallback() {
    fetch("/wp-json/badaxe/v1/location/list")
      .then((response) => response.json())
      .then((data) => {
        this.locations = data;
        this.render();
      });
  }

  render() {
    this.innerHTML = "";
    const container = document.createElement("div");

    container.innerHTML = `
    <div class="container mx-auto pt-8 pb-4 h-auto md:min-h-sectionsm xl:min-h-sectionmd 2xl:min-h-sectionlg flex items-center justify-center">
        <div class="w-full px-0 mx-auto">
            <header class="mb-3 md:mb-6">
                <h3 class="uppercase text-xl md:text-3xl text-center text-white">
                    <span class="font-semibold">Select a Location</span> Near You
                </h3>
                <p class="text-center mt-2 text-base md:text-base px-4 md:px-0 leading-5 md:leading-0 text-white">
                    Select a Country to Find our nearest Location
                </p>
            </header>
            <div class="flex flex-row flex-wrap justify-evenly items-center my-0 md:my-4">
                <button data-country="canada" class="btn-country btn-canada border-2 border-gray-400 hover:border-black mb-2 md:mb-0 w-72 md:w-56 md:h-24 transition ease-in-out relative outline-none">
                    CA
                </button>
                <button data-country="us" class="btn-country btn-us border-2 border-gray-400 hover:border-black mb-2 md:mb-0 w-72 md:w-56 md:h-24 transition ease-in-out relative outline-none">
                    U.S.
                </button>
            </div>
            <div class="my-0 md:my-4 px-4 sm:px-0">
                <ul id="locations-list" class="flex flex-row flex-wrap justify-center md:justify-evenly mt-6 mb-2 items-center bg-gray-100 rounded-md p-0"></ul>
            </div>
        </div>
    </div>
    `;

    this.appendChild(container);

    this.querySelectorAll(".btn-country").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const ulList = this.querySelector("#locations-list");
        ulList.classList.add("p-8");
        ulList.innerHTML = this.populateLocations(e.target.dataset.country);
      });
    });
  }

  populateLocations(country) {
    let locationsList = "";
    this.locations.forEach((location) => {
      if (!this.blockedLocations.includes(location.name.toLowerCase())) {
        if (country.toLowerCase() === location.country.toLowerCase()) {
          locationsList += `
            <li class="w-2/5 md:text-base md:pr-0 md:w-initial md:flex-none md:w-1/4 mx-2 my-2 border-b-2 border-gray-400">
              <a href="${location.url}" target="_blank" class="relative font-semibold text-sm md:text-lg block py-3 md:py-6 px-2 hover:bg-brand hover:text-white btn-locations leading-4 md:leading-0">
                ${location.name}
                <span class="text-gray-300 text-xs block md:inline-block">${location.region}</span>
              </a>
            </li>
            `;
        }
      }
    });
    return locationsList;
  }

  disconnectedCallback() { }
}
